import sensors from 'sa-sdk-javascript';
import pageleave from 'sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js';

let initialized = false;

/** PC/H5 共用 Web SDK；配置数据接收地址后启用。 */
export const initSensors = (): boolean => {
    if (initialized) return true;
    const serverUrl = process.env.REACT_APP_SENSORS_SERVER_URL?.trim();
    if (!serverUrl) return false;

    try {
        const url = new URL(serverUrl);
        if (!['http:', 'https:'].includes(url.protocol)) {
            throw new Error('神策数据接收地址必须使用 HTTP 或 HTTPS');
        }

        let previousPage = window.location.pathname + window.location.search;
        sensors.init({
            server_url: serverUrl,
            // 忽略同一页面的锚点变化及重复 replace，避免重复统计浏览量。
            is_track_single_page: () => {
                const currentPage = window.location.pathname + window.location.search;
                if (currentPage === previousPage) return false;
                previousPage = currentPage;
                return true;
            },
            use_client_time: true,
            send_type: 'beacon',
            show_log: process.env.REACT_APP_SENSORS_SHOW_LOG === 'true',
            heatmap: {
                clickmap: 'default',
                scroll_notice_map: 'not_collect',
            },
            collect_tags:{
                div : true
            }
        });
        // 在首个事件前标记平台，用于共享测试项目中区分 vivo/iQOO。
        sensors.registerPage({ platform_type: 'vivo' });
        // PC/H5 所有页面启用停留时长采集，页面离开或路由切换时上报 $WebPageLeave。
        sensors.use(pageleave, {
            heartbeat_interval_time: 5,
            max_duration: 5 * 24 * 60 * 60,
            // 所有页面均采集浏览时长。
            isCollectUrl: () => true,
        });
        sensors.quick('autoTrack');
        initialized = true;
        return true;
    } catch (error) {
        // 统计初始化失败不影响页面启动。
        console.warn('神策 SDK 初始化失败', error);
        return false;
    }
};

export default sensors;
